/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./CSelect.vue?vue&type=template&id=2f065368"
import script from "./CSelect.vue?vue&type=script&lang=js"
export * from "./CSelect.vue?vue&type=script&lang=js"
import style0 from "./CSelect.vue?vue&type=style&index=0&id=2f065368&prod&lang=scss"
import style1 from "./CSelect.vue?vue&type=style&index=1&id=2f065368&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports